export const golfEn = {
  golf: {
    title: "Golf Course Management",
    subtitle: "Professional turf monitoring • USGA/GCSAA standards",
    zonesRegistered: "{{count}} zone(s) registered",
    courseDiary: "Course Diary",
    exportReport: "Export Report",
    generatingReport: "Generating...",
    addGolfZones: "Add Golf Zones",
    noZonesTitle: "No Golf Zones Added",
    noZonesDesc: "Add your golf course zones (Greens, Fairways, Tees, Rough) as parcels to start monitoring with real satellite data, irrigation optimization, and disease risk models.",
    cropTypeHint: "When adding parcels, select one of these crop types:",
    loadingData: "Loading golf course data...",
    // KPIs
    turfScore: "Turf Score™",
    greenSpeed: "Green Speed (ft)",
    stimpeterEst: "Stimpmeter est.",
    noGreensData: "No greens data",
    avgMoisture: "Avg. Moisture",
    compactionAlerts: "Compaction Alerts",
    diseaseWatch: "Disease Watch",
    // Alerts
    superintendentAlert: "Superintendent Alert:",
    compactionHighRec: "— high compaction risk detected. Aeration recommended.",
    diseasePressureHigh: "— high disease pressure.",
    noSatelliteTitle: "No satellite analysis data available yet.",
    noSatelliteDesc: "Run a satellite analysis on your parcels to populate NDVI, moisture, and risk metrics.",
    // Tabs
    zoneOverview: "Zone Overview",
    irrigationPlan: "Irrigation Plan",
    turfHealth: "Turf Health",
    maintenanceLog: "Maintenance Log",
    trends: "Trends",
    // Zone cards
    ndviPending: "NDVI: pending",
    moisturePending: "Moisture: pending",
    compaction: "Compaction",
    disease: "Disease",
    // Irrigation tab
    irrigationSchedule: "Irrigation Schedule",
    irrigationEmptyDesc: "Run the Irrigation Optimizer on your golf zones to generate FAO-56 based irrigation schedules.",
    goToIrrigation: "Go to Irrigation Optimizer",
    waterEfficiency: "Water Use Efficiency",
    waterEfficiencyEmpty: "Water efficiency metrics will appear once irrigation plans are calculated for your zones.",
    // Health tab
    diseasePressure: "Disease Pressure Monitor",
    diseasePressureDesc: "Based on GDD models from pest-disease-risk-v3 engine",
    noDisease: "No disease alerts detected. Run satellite analysis to update risk models.",
    nutrientStatus: "Nutrient Status",
    nutrientStatusDesc: "Track via Fertilization module",
    nutrientEmpty: "Nutrient tracking data will populate from the Fertilization module when field activities are recorded.",
    goToFertilization: "Go to Fertilization",
    // Maintenance tab
    superintendentLog: "Course Diary — Superintendent Log",
    superintendentLogDesc: "Record daily maintenance tasks and observations",
    noMaintenance: "No maintenance entries yet. Use the Field Notebook to log daily course activities.",
    openFieldNotebook: "Open Field Notebook",
    // Grass info
    grassSpecies: "Grass Species & Management Parameters",
    grassSpeciesDesc: "USGA/GCSAA reference values for your registered zone types",
    cutHeight: "Cut height",
    nMax: "N max",
    // Trends tab
    trendsTitle: "NDVI & Moisture Trends",
    trendsDesc: "Historical evolution from satellite data (last 90 days)",
    noTrendsData: "Run satellite analyses over time to see trend data here.",
    ndvi: "NDVI",
    moisture: "Moisture (%)",
    // Risk levels
    riskLow: "low",
    riskMedium: "medium",
    riskHigh: "high",
    // Zone types
    greens: "Greens",
    fairways: "Fairways",
    teeBoxes: "Tee Boxes",
    rough: "Rough",
    // PDF Report
    reportTitle: "Golf Course Management Report",
    reportGenerated: "Generated",
    reportZoneSummary: "Zone Summary",
    reportGrassParams: "Grass & Management Parameters",
    reportDisclaimer: "Report generated by Sentinel Crop. Turf Score™ and Green Speed are estimations based on satellite and meteorological data.",
  }
};
